/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StarClubChallengeTile',['pixi', 'absolute', 'lodash', 'Solitaire/SolitaireGameMode', 'MenuUI/MenuTile', 'Managers/TelemetryManager'],

    function (PIXI, Absolute, _, SolitaireGameMode, MenuTile, TelemetryManager) {

        var StarClubChallengeTile = function (config, challenge, challengeMenu) {
            var defaultConfig = {};
            this.initStarClubChallengeTile(_.extend(defaultConfig, config), challenge, challengeMenu);
        };

        StarClubChallengeTile.prototype = Object.create(MenuTile.prototype);

        StarClubChallengeTile.prototype.initStarClubChallengeTile = function (config, challenge, challengeMenu) {

            this.challengeMenu = challengeMenu;
            this.challenge = challenge;

            MenuTile.call(this, config);

            this.label.x = (this.width - this.label.width) / 2;
            this.label.y = Absolute.Coords.y(216);

            var hr = new PIXI.Graphics(),
                hrWidth = Absolute.Coords.x(200),
                lineWeight = Absolute.Coords.x(4),
                descriptionStyle = {
                    font: Absolute.ScreenMetrics.getResScale() * 25 + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'center'
                },
                description = new PIXI.Text(this.challenge.ShortGoalDescription, descriptionStyle),
                difficultyBar = new PIXI.Graphics(),
                difficultyStyle = {
                    font: Absolute.ScreenMetrics.getResScale() * 28 + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'center'
                },
                difficultyStrings = Absolute.StringManager('difficulty', null, true),
                difficulty = new PIXI.Text(difficultyStrings[this.challenge.Difficulty - 1], difficultyStyle);

            hr.moveTo(0, 0);
            hr.lineStyle(lineWeight, 0xffffff, 1);
            hr.lineTo(hrWidth, 0);
            hr.x = (this.width - hrWidth) / 2;
            hr.y = Absolute.Coords.y(262);
            this.addChild(hr);

            description.x = (this.width - description.width) / 2;
            description.y = Absolute.Coords.y(270);
            this.addChild(description);

            difficultyBar.beginFill(0x000000, 0.7);
            difficultyBar.drawRect(0, 0, this.width, Absolute.Coords.y(40));
            difficultyBar.endFill();
            this.addChild(difficultyBar);

            difficulty.x = Absolute.Coords.x(10);
            difficulty.y = Absolute.Coords.y(3);
            this.addChild(difficulty);

            _.times(this.challenge.Difficulty, function (count) {
                var difficultyStar = PIXI.Sprite.fromFrame('dailychallenge/challenge_diff_star.png');
                //difficultyStar.anchor.x = difficultyStar.width;
                difficultyStar.x = this.width - difficultyStar.width - Absolute.Coords.x(10) - count * (difficultyStar.width + Absolute.Coords.x(5));
                difficultyStar.y = Absolute.Coords.y(5);
                this.addChild(difficultyStar);
            }, this);

            if (this.challenge.Completed) {
                this.complete = true;
                var completeRibbon = PIXI.Sprite.fromFrame('dailychallenge/ribbon_DC.png');
                completeRibbon.x = (this.width - completeRibbon.width) / 2;
                completeRibbon.y = Absolute.Coords.y(107);
                this.addChild(completeRibbon);
            }

        };

        StarClubChallengeTile.prototype.handleClick = function () {                        
            this.challengeMenu.game.startGame(SolitaireGameMode[this.config.mode], this.challenge);
        };

        StarClubChallengeTile.prototype.onShow = function () {

            if (this.complete !== this.challenge.Completed && this.challenge.Completed) {
                this.completeRibbon = PIXI.Sprite.fromFrame('dailychallenge/ribbon_DC.png'),
                    startingScale = 3,
                    self = this;
                // hack bring this tile to the top
                this.parent.addChild(this);
                this.completeRibbon.anchor.x = this.completeRibbon.anchor.y = 0.5;
                this.completeRibbon.x = this.width / 2;
                this.completeRibbon.y = Absolute.Coords.y(190);
                this.completeRibbon.scale.x = this.completeRibbon.scale.y = startingScale;
                this.completeRibbon.alpha = 0;
                this.addChild(this.completeRibbon);
                this.complete = this.challenge.Completed;

                Absolute.AudioManager.playSound('sc_starFlying');

                window.setTimeout(function () {
                    Absolute.AudioManager.playSound('dc_ribbonHit');
                }, 800);

                this.ribbonTween = new TWEEN.Tween({scale: startingScale, alpha: 0})
                    .easing(TWEEN.Easing.Cubic.In)
                    .to({scale: 1, alpha: 1}, 1000)
                    .onUpdate(function () {
                        self.completeRibbon.scale.x = self.completeRibbon.scale.y = this.scale;
                        self.completeRibbon.alpha = this.alpha;
                    })
                    .onComplete(function () {
                        self.challengeMenu.onChallengeCompleted(self)
                        self.interactive = true;
                    })
                    .start();
            } else {
                this.interactive = true;
            }
        };

        StarClubChallengeTile.prototype.onHide = function () {
            if (this.completeRibbon) {
                this.completeRibbon.scale.x = this.completeRibbon.scale.y = 1;
                this.completeRibbon.alpha = 1;
            }
            if (this.ribbonTween) {
                this.ribbonTween.stop();
            }
            TWEEN.removeAll();
            this.interactive = false;
            this.hover.visible = false;
        };

        return StarClubChallengeTile;

    });

